export default __webpack_public_path__ + "static/bigData-a490c19021ba487b9fdc81894053380b.jpg";